import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { PageEvent, MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { Patient } from '../../../core/models/patient/patient';
import { ReferralsService } from '../../../referrals/referrals.service';
import { PhysicianOptionService } from '../../shared/physician-option/physician-option.service';
import { Referral } from '../../../core/model/v2/appointment/referral';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { UserService } from '../../../core/services/v2/user.service';
import { WindowLoaderService } from '../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-referal-list',
  templateUrl: './patient-referal-list.component.html',
  styleUrls: ['./patient-referal-list.component.scss']
})
export class PatientReferalListComponent implements OnInit {

  @ViewChild('paginator', { static: true }) paginator: MatPaginator;

  patientData: Patient;

  referrals: Referral[];

  displayedColumns = ['referralDate', 'referralFrom', 'symptoms', 'icdcCode', 'urgencyType'];

  pageLength = 10;
  pageIndex = 1;
  totalRecords = 0;
  requestFilter = {
    practitionerId: undefined,
    patientId: undefined,
    pageIndex: 1,
    itemsCount: 10
  };

  currentUserId: number;
  constructor(
    private referralService: ReferralsService,
    private userService: UserService,
    public dialogRef: MatDialogRef<PatientReferalListComponent>,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.patientData = data.patientData;

    }
  }

  ngOnInit() {
    this.getReferral();
  }

  close() {
    this.dialogRef.close();
  }

  getReferral(): void {

    this.requestFilter = {
      practitionerId: this.physicianOptionService.getPhysician().id,
      patientId: this.patientData.id,
      pageIndex: this.pageIndex,
      itemsCount: this.pageLength
    };

    this.loaderService.show();

    this.userService.getUserDetails().subscribe(
      (me) => { this.currentUserId = me.id; },
      (error) => { console.error(error); }
    );
    
    this.referralService.getPatientReferralList(this.requestFilter).subscribe(
      (response) => {
        if (response['response']['isSuccess']) {
          this.totalRecords = response['totalRecords'];
          this.referrals = response['practitionerReferralDetail'];
        }
      },
      (error) => { console.error(error); },
      () => { this.loaderService.hide(); }
    );
  }

  changeIndex(event: PageEvent) {
    this.pageLength = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.getReferral();
  }
}
